<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
// import Rem from "./utils/rem.js";
// import '@/utils/rem.js'
export default {

}
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
}

// 隐藏table 出现滚动条后的横线
body .el-table::before {
  z-index: inherit;
}

.el-message--error .el-message__content {
  color: #f56c6c !important;
}

.el-popper {
  margin-left: 15px !important;
}

div {
  box-sizing: border-box;
}

body {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  background: #0B1119;// 因为数据大屏而增加
  
}

.el-dropdown-menu {
  background-color: rgb(31, 31, 31) !important;
  border: 0px !important;
}

.el-dropdown-menu__item {
  line-height: 20px !important;
}

.el-dropdown-menu__item:hover {
  background-color: rgba(31, 31, 31, .5) !important;
  color: white !important;
}

.el-popper .popper__arrow,
.el-popper .popper__arrow::after {
  // border-bottom-color: rgb(31, 31, 31) !important;
  opacity: 0;
}

th {
  font-weight: normal;
}

#app {
  font-family: ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100vw;

}

.el-button--primary.is-plain {
  color: white !important;
}

.el-table th {
  background: #F1F3F9 !important;
  height: 58px !important;
  color: #000000 !important;
}

// .el-table th.el-table__cell{
//     background-color: #353535 !important;
//     color: white !important;
// }
// .el-table td.el-table__cell{
//   // background-color: #000000 !important;
//   // color: white !important;
// }
// .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
//   border: 0px !important;
// }
// .el-table, .el-table__expanded-cell{
//   background: none !important;
// }
// .el-table::before{
//   background: none !important;
// }
.pinkie {
  cursor: pointer;
}

.el-message--success {
  background-color: var(--subject-color) !important;
  border-color: var(--subject-color) !important;

}

.el-icon-success,
.el-message__content {
  color: var(--subject-text-color) !important;
}

nav {
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.el-popper {
  z-index: 100000000 !important;
}

.codex-editor__redactor {
  padding-bottom: none !important;
}
</style>
